module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "response-container"
  }, [_c('h1', [_vm._v("PCS 05 API Response")]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Interface Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": "",
      "id": "interfaceName",
      "name": "interfaceName"
    },
    model: {
      value: (_vm.interfaceName),
      callback: function($$v) {
        _vm.interfaceName = $$v
      },
      expression: "interfaceName"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("BOE Number (2219940)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "boeNumber",
      "name": "boeNumber"
    },
    model: {
      value: (_vm.boeNumber),
      callback: function($$v) {
        _vm.boeNumber = $$v
      },
      expression: "boeNumber"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [(_vm.interfaceName && _vm.boeNumber) ? _c('b-button', {
    staticStyle: {
      "font-size": "0.675rem",
      "margin-left": "5px",
      "margin-bottom": "4px"
    },
    attrs: {
      "size": "sm",
      "variant": "info"
    },
    on: {
      "click": function($event) {
        _vm.getAllPCS05Func()
      }
    }
  }, [_vm._v("Fetch")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.getAllPcs05 ||
    !_vm.getAllPcs05.response ||
    _vm.getAllPcs05.response[0].responseMsg === 'not found'
  ) ? _c('div', [_c('b', {
    staticClass: "text-danger"
  }, [_vm._v("No data found.")])]) : (_vm.getAllPcs05.responseStatus === 'SUCCESS') ? _c('div', _vm._l((_vm.getAllPcs05.response), function(entry, index) {
    return _c('b-row', {
      key: index,
      staticClass: "mt-2 mb-2"
    }, [_c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('strong', [_vm._v("Sub Line No:")]), _vm._v(" " + _vm._s(entry.subLineNo || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('strong', [_vm._v("Items Bill Of Entry Date:")]), _vm._v("\n          " + _vm._s(entry.items_BillOfEntryDate || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('strong', [_vm._v("IGM No:")]), _vm._v(" " + _vm._s(entry.igmNo || "N/A") + " ")]), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('strong', [_vm._v("Out of Charge No:")]), _vm._v(" " + _vm._s(entry.out_of_charge_no || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('strong', [_vm._v("IGM Date:")]), _vm._v(" " + _vm._s(entry.igmDate || "N/A") + " ")]), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('strong', [_vm._v("Number of Packages:")]), _vm._v(" " + _vm._s(entry.numberOfPackages || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('strong', [_vm._v("Out of Charge Date:")]), _vm._v(" " + _vm._s(entry.out_of_charge_date || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('strong', [_vm._v("Sub Line Number:")]), _vm._v(" " + _vm._s(entry.sub_line_number || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('strong', [_vm._v("Line No:")]), _vm._v(" " + _vm._s(entry.lineNo || "N/A") + " ")]), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('strong', [_vm._v("Line Number:")]), _vm._v(" " + _vm._s(entry.line_number || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('strong', [_vm._v("Bill of Entry No:")]), _vm._v(" " + _vm._s(entry.billOfEntryNo || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('strong', [_vm._v("Container No:")]), _vm._v(" " + _vm._s(entry.container_no || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('strong', [_vm._v("CHA Code:")]), _vm._v(" " + _vm._s(entry.chaCode || "N/A") + " ")]), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('strong', [_vm._v("Items Bill Of Entry No:")]), _vm._v("\n          " + _vm._s(entry.items_BillOfEntryNo || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('strong', [_vm._v("Response Message:")]), _vm._v(" " + _vm._s(entry.responseMsg || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('strong', [_vm._v("Items Sub Line No:")]), _vm._v(" " + _vm._s(entry.items_SubLineNo || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('strong', [_vm._v("Items IGM No:")]), _vm._v(" " + _vm._s(entry.items_IgmNo || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('strong', [_vm._v("Nature Of Cargo:")]), _vm._v(" " + _vm._s(entry.natureOfCargo || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('strong', [_vm._v("Items IGM Date:")]), _vm._v(" " + _vm._s(entry.items_IgmDate || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('strong', [_vm._v("Items Custom House Code:")]), _vm._v("\n          " + _vm._s(entry.items_CustomHouseCode || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('strong', [_vm._v("Custom House Code:")]), _vm._v(" " + _vm._s(entry.customHouseCode || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('strong', [_vm._v("Items Line Number:")]), _vm._v(" " + _vm._s(entry.items_LineNumber || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('strong', [_vm._v("Country of Origin:")]), _vm._v(" " + _vm._s(entry.countryOfOrigin || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('strong', [_vm._v("Unit of Quantity:")]), _vm._v(" " + _vm._s(entry.unitOfQuantity || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('strong', [_vm._v("Bill of Entry Date:")]), _vm._v(" " + _vm._s(entry.billOfEntryDate || "N/A") + "\n        ")]), _vm._v(" "), _c('hr')], 1)
  })) : _c('div', [_c('p', [_vm._v("No data found.")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b5b4ae20","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/ulip/PCS05_ResponseDisplay.vue
// module id = 2842
// module chunks = 0